export default [

  {
    path: '/',
    name:'login',
    component: (resolve) => require(['../components/pages/Login'], resolve)//实现懒加载
  },
  {
    path: '/login',
    name:'login',
    component: (resolve) => require(['../components/pages/Login'], resolve)//实现懒加载
  }

]



// WEBPACK FOOTER //
// ./src/router/loginRoute.js